import { render, staticRenderFns } from "./ShowContent.vue?vue&type=template&id=5bfcfcdc&scoped=true"
import script from "./ShowContent.vue?vue&type=script&lang=js"
export * from "./ShowContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfcfcdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfcfcdc')) {
      api.createRecord('5bfcfcdc', component.options)
    } else {
      api.reload('5bfcfcdc', component.options)
    }
    module.hot.accept("./ShowContent.vue?vue&type=template&id=5bfcfcdc&scoped=true", function () {
      api.rerender('5bfcfcdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/ShowContent.vue"
export default component.exports